import { render, staticRenderFns } from "./GroupAttendaceDetail.vue?vue&type=template&id=52e89234&scoped=true&"
import script from "./GroupAttendaceDetail.vue?vue&type=script&lang=js&"
export * from "./GroupAttendaceDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupAttendaceDetail.vue?vue&type=style&index=0&id=52e89234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e89234",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDataTable,VPagination,VRow,VTab,VTabs})
